import { observer } from "src/shared/util/Observer";
import { IGameServer, InitialResponse, SpinResponse } from "src/shared/util/Types";
import { GlobalState } from "src/shared/util/GlobalState"; // Adjust the path as needed

export class Connector implements IGameServer {
    private gameId: string;
    private playerId: string;
    baseUrl: string;
    isDebug: boolean = false; // Set to true for local testing

    constructor() {
        const params = new URLSearchParams(window.location.search);
        const gameId = params.get("gameId") || "risingcup"; // Default value if not provided
        const playerId = params.get("playerId") || "player1"; // Default value if not provided

        if (!gameId || !playerId) {
            throw new Error("Missing gameId or playerId in URL");
        }

        this.gameId = gameId;
        this.playerId = playerId;

        this.baseUrl = this.isDebug ? "http://localhost:3000" : "https://slot-backend-190897502095.us-central1.run.app";
    }

    public async getInitialState(): Promise<void> {
        try {
            const response = await fetch(`${this.baseUrl}/init`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    gameId: this.gameId,
                    playerId: this.playerId
                }),
            });

            if (!response.ok) throw new Error(await response.text());

            const data: InitialResponse = await response.json();
            observer.publish("init", data);
        } catch (error) {
            console.error("Failed to fetch initial state:", error);
        }
    }

    public async gameAction(rig?: string): Promise<void> {
        try {
            const bet = GlobalState.getInstance().bet;

            const response = await fetch(`${this.baseUrl}/spin`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    gameId: this.gameId,
                    playerId: this.playerId,
                    bet: bet,
                    rig
                }),
            });

            if (!response.ok) throw new Error(await response.text());

            const data: SpinResponse = await response.json();
            observer.publish("spin", data);
        } catch (error) {
            console.error("Failed to perform spin:", error);
        }
    }

    public on(eventName: string, callback: (data: any) => void): void {
        observer.on(eventName, callback);
    }

    public off(eventName: string, callback: (data: any) => void): void {
        observer.off(eventName, callback);
    }

    public onInitialStateResult(callback: (data: InitialResponse) => void): void {
        observer.on("init", callback);
    }

    public onGameActionResult(callback: (data: SpinResponse) => void): void {
        observer.on("spin", callback);
    }
}
